<template>
  <!-- страница корзины -->
  <div class="mb-4">
    <div v-if="loading" aria-hidden="true" class="placeholder-glow row">
      <!-- placeholder -->
      <span class="placeholder col-10 ms-2 mb-2"></span>
      <span class="placeholder col-5 ms-2 mb-2"></span>
      <span class="placeholder col-3 ms-2 mb-2"></span>
      <a href="#" tabindex="-1" class="btn btn-primary ms-2 mb-2 disabled placeholder col-5" aria-hidden="true"></a>
    </div>
    <template v-else>
      <template v-if="amount == 0"
        >{{ str1 }} <nobr class="fw-medium">{{ str2 }}</nobr
        ><br />
        <a v-if="page == 'order'" href="/cart" class="mt-3">Назад к корзине</a>
      </template>
      <template v-else
        >{{ str1 }} <nobr class="fw-medium">{{ str2 }}</nobr>
        <template v-if="orderTotal">
          <nobr>
            на сумму <span class="fw-medium">{{ orderTotal }} ₽</span></nobr
          ></template
        ><br />
        <a v-if="page == 'order'" href="/cart" class="mt-3">Назад к корзине</a>
        <a v-if="page == 'cart'" href="/order" class="btn btn-primary mt-3">Оформить заказ</a>
      </template>
    </template>
  </div>
</template>

<script>
import { plural } from '@/composable/functions';

export default {
  name: 'OrderTotal',
  props: {
    order: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    orderTotal: {
      type: Number,
      default: 0,
      required: true,
    },
    page: {
      type: String,
      default: '',
      required: true,
    },
  },
  data: function () {
    return {
      loading: true,
      //
      amount: 0,
      str1: '',
      str2: '',
    };
  },
  computed: {
    //
  },
  watch: {
    order: {
      deep: true,
      // eslint-disable-next-line
      handler(val, oldVal) {
        this.loading = true;

        this.amount = 0;
        if (Object.keys(val).length) {
          this.amount = Object.values(val).reduce((total, item) => parseInt(total) + parseInt(item['amount']), 0);
        }

        this.str1 = 'Товары не выбраны.';
        this.str2 = '';

        if (this.amount > 0) {
          this.str1 = plural(this.amount, `Выбран`, `Выбраны`, `Выбрано`);
          this.str2 = plural(this.amount, `${this.amount} товар`, `${this.amount} товара`, `${this.amount} товаров`);
        }

        this.loading = false;
      },
    },
  },
  created() {
    this.loading = true;
  },
  methods: {
    //
  },
};
</script>
